import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from 'constants/query-keys'
import { IGenericResponse } from 'utils/api'
import { TIME } from 'utils/misc'
import { useAnalytics } from 'utils/analytics'
import { fetchMyTargetPerformanceMetricInfo } from 'queries/myTarget-performance/performance-metrics'
import { MPMEnvType } from 'utils/env'
import { isStore } from 'utils/location'
import { Metric } from 'pages/myTarget-performance/types'

interface MyTargetPerformanceMetricInfoFetchProps {
    env: MPMEnvType
    accessToken: string
    location: string
}

export function useMyTargetPerformanceMetricInfo({
    env,
    accessToken,
    location,
}: MyTargetPerformanceMetricInfoFetchProps): IGenericResponse<Metric[]> {
    const { trackEvent } = useAnalytics()
    const { tenMinutes } = TIME

    // Only pass location_id for stores, and strip the "T" prefix
    const filters = isStore(location)
        ? { location_id: location.slice(1) }
        : undefined

    const { data, isLoading, isError, refetch, remove, error } = useQuery(
        [QueryKeys.MY_TARGET_PERFORMANCE_METRIC_INFO, location],
        () =>
            fetchMyTargetPerformanceMetricInfo({
                env,
                accessToken,
                filters,
                trackEvent,
            }),
        {
            staleTime: tenMinutes,
            cacheTime: tenMinutes,
            retry: false,
        },
    )

    return { data, isLoading, isError, refetch, remove, error }
}
